<div [class.row]="isList" class="px-0" role="region" aria-label="Prize Draws">
  @if (isLoaded()) {
    <ng-container *ngIf="lottos()">
      <ng-container *ngIf="lottos().length; else noLottos">
        <ng-container *fgbWebsiteContentFeatureFlag="'fgbcl.feature.flag.lotto.sortbar'">
          <fgbcl-sort-bar
            class="row w-100"
            [sortBarOptions]="sortBarOptions"
            [displayDefaultSort]="true"
            (sortChange)="onSortChange($event)"
          ></fgbcl-sort-bar>
        </ng-container>
        <ul role="list" class="list-unstyled" [class.row]="isList" aria-label="Prize draws list">
          @for (item of lottos(); track item.LottoId) {
            <li [class.col-6]="isList" [class.col-lg-4]="isList">
              <div class="loyalty-item-container">
                <fgbcl-lottos-list-item-v2 [lottoItem]="item" [featuredIcon]="featuredIcon" />
              </div>
            </li>
          }
        </ul>
      </ng-container>
    </ng-container>
  } @else {
    <!-- Loading -->
    <ng-container *ngTemplateOutlet="loadingRef"></ng-container>
  }
</div>

<!-- No results -->
<ng-template #noLottos>
  <div class="rewards-placholder" role="status" aria-live="polite">
    <div class="no-items no-results-placeholder-div">
      <img
        class="svg svg-info vs-svg ms-auto me-auto"
        fgbAnimateSvg
        [src]="'placeholders/prizedraws.svg' | contentAssetImage"
        aria-hidden="true"
      />
      <div class="no-results-placeholder" role="status">{{ 'lotto.placeholder.description' | translate }}</div>
    </div>
  </div>
</ng-template>

<!-- Loading Template -->
<ng-template #loadingRef>
  <div class="w-100" role="status" aria-live="polite" aria-label="Loading prize draws">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>
